import { Controller } from 'stimulus'
import gsap, { Power1, Power4 } from 'gsap'

export default class extends Controller {
  static targets = [
    'word',
    'wordLine',
    'wordBorder',
    'heroCatchLine',
    'heroText',
    'heroLogo',
    'heroLogoPath',
    'heroLink',
  ]

  connect() {
    const vh = window.innerHeight * 0.01
    this.element.style.setProperty('--vh', `${vh}px`)
    console.log(this.element)
  }

  loaded() {
    const windowIsMobileSize = window.matchMedia("(max-width: 768px)").matches
    const windowHasTouchEvent = "ontouchend" in document && "orientation" in window

    if (windowIsMobileSize && windowHasTouchEvent) {
      this.wordTargets.forEach(($word) => {
        $word.style.display = 'inline';
      })
    }
    const timeline = gsap.timeline({
      repeat: 0,
      default: {
        duration: 0.1,
        ease: Power1.easeOut,
      },
    })

    window.setTimeout(() => {
      // gsap init
      if (!windowIsMobileSize) {
        timeline.set(this.wordLineTarget, {
          left: '50%',
          x: '-50%',
        })
      }

      // words typewriter
      if (windowIsMobileSize && windowHasTouchEvent) {
        timeline.to(this.heroTarget, {
          opacity: 1,
          duration: 2,
          ease: Power4.easeOut,
        })
      } else {
        timeline
          .to(this.wordTargets[0], {
            display: 'inline',
            duration: 0.08,
          })
          .to(this.wordTargets[1], {
            display: 'inline',
            duration: 0.08,
          })
          .to(this.wordTargets[2], {
            display: 'inline',
            duration: 0.08,
          })
          .to(this.wordTargets[3], {
            display: 'inline',
            duration: 0.25,
          })
          .to(this.wordTargets[4], {
            display: 'inline',
            duration: 0.08,
          })
          .to(this.wordTargets[5], {
            display: 'inline',
            duration: 0.08,
          })
          .to(this.wordTargets[6], {
            display: 'inline',
            duration: 0.09,
          })
          .to(this.wordTargets[7], {
            display: 'inline',
            duration: 0.3,
          })
          .to(this.wordTargets[8], {
            display: 'inline',
            duration: 0.09,
          })
          .to(this.wordTargets[9], {
            display: 'inline',
            duration: 0.1,
          })
          .to(this.wordTargets[10], {
            display: 'inline',
            duration: 0.11,
          })
          .to(this.wordTargets[11], {
            display: 'inline',
            duration: 0.12,
          })
          .to(this.wordTargets[12], {
            display: 'inline',
          })
          .to(this.wordTargets[13], {
              display: 'inline',
              duration: 1,
            },
            '<'
          )
      }

      // gsap logo
      if (windowIsMobileSize && windowHasTouchEvent) {
        timeline
          .fromTo(this.heroLogoTarget, {
              x: '0%',
              opacity: 0,
              scaleX: 1.5,
              transformOrigin: 'right',
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
              scaleX: 1,
              duration: 1.0,
              delay: 0,
              ease: Power4.easeOut,
            },
            '<'
          )
          .to(this.heroLogoPathTarget, {
              strokeDashoffset: 0,
              duration: 2,
              ease: Power4.easeOut,
            },
            '<'
          )
      } else {
        timeline
          .fromTo(this.heroLogoTarget, {
              x: '-90%',
              opacity: 0,
              scaleX: 1.5,
              transformOrigin: 'right',
              ease: Power4.easeOut,
            }, {
              x: '-90%',
              opacity: 1,
              scaleX: 1,
              duration: 0.4,
              delay: 0,
              ease: Power4.easeOut,
            }
          )
          .to(this.heroLogoPathTarget, {
              strokeDashoffset: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            },
            "<"
          )
      }

      // finish
      if (windowIsMobileSize && windowHasTouchEvent) {
        timeline
          .to(this.heroLogoTarget, {
            x: '200%',
            scaleX: 1.4,
            duration: 1,
            opacity: 0,
            ease: Power4.easeOut,
          })
          .fromTo(this.heroCatchLineTargets[0], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<20%'
          )
          .fromTo(this.heroTextTarget, {
              x: '-20%',
              opacity: 0,
              ease: Power4.easeIn,
              transformOrigin: 'left',
            }, {
              x: '0%',
              duration: 0.4,
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.heroLinkTarget, {
              x: '-20%',
              opacity: 0,
              ease: Power4.easeIn,
            }, {
              x: '0%',
              duration: 0.4,
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.heroCatchLineTargets[1], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<25%'
          )
          .fromTo(this.heroCatchLineTargets[2], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<25%'
          )
      } else {
        timeline
          .to(this.wordLineTarget, {
            left: 0,
            x: 0,
            scaleX: 1,
            duration: 0.5,
            delay: 0.2,
            ease: Power4.easeOut,
          })
          .fromTo(this.heroTextTarget, {
              x: '-50%',
              opacity: 0,
              duration: 0.6,
              ease: Power4.easeOut,
              transformOrigin: 'left',
            }, {
              x: '0%',
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.heroLogoTarget, {
              transformOrigin: 'left',
            }, {
              x: '0%',
              duration: 0.8,
              ease: Power4.easeOut,
              transformOrigin: 'left',
            },
            '<'
          )
          .fromTo(this.heroLinkTarget, {
              x: '-50%',
              opacity: 0,
              duration: 0.6,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.wordBorderTarget, {
              opacity: 0,
            }, {
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.heroCatchLineTargets[0], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<'
          )
          .fromTo(this.heroCatchLineTargets[1], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<25%'
          )
          .fromTo(this.heroCatchLineTargets[2], {
              x: '-20%',
              opacity: 0,
              duration: 0.2,
              ease: Power4.easeOut,
            }, {
              x: '0%',
              opacity: 1,
            },
            '<25%'
          )
      }
    }, 500)
  }
}
